jQuery(document).ready(function () {
  var dark = "rgba(0,0,0,0.5)";
  var light = "rgba(0,0,0,0.25)";
  $("#mobile-view").on("click", function () {
    $("#desktop-view").css({
      fill: light,
    });
    $("#mobile-view").css({
      fill: dark,
    });
    $("#preview-content-iframe").css({
      "min-width": "380px",
      width: "380px",
    });
    $("#preview-content").css({
      "min-width": "380px",
      width: "380px",
    });
    return false;
  });

  $("#desktop-view").on("click", function () {
    $("#mobile-view").css({
      fill: light,
    });
    $("#desktop-view").css({
      fill: dark,
    });
    $("#preview-content-iframe").width("100%");
    $("#preview-content").width("100%");
    return false;
  });
  $(".preview-link").on("click", function (event) {
    event.preventDefault();
    var emailId = $(this).data("email-id");
    var iframeURL =
      "https://orderlyemails.com/external_preview?id={{ product.selected_or_first_available_variant.sku }}&email_type_id=" +
      emailId;
    console.log(emailId);
    $("#preview-content-iframe").attr("src", iframeURL);
    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top - 80,
      },
      800
    );
    return false;
  });
});

// returns the cookie with the given name,
// or undefined if not found
function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {
  options = {
    path: "/",
    // add other defaults here if necessary
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}


// Save shop to cookie, if known
$(document).ready(function () {
  var urlParams = new URLSearchParams(window.location.search);
  var shop = urlParams.get("shop");

  if (shop) {
    setCookie("shop", shop, { expires: 7, path: "/" });
  } else {
  }
});

// Update links with shop from cookie, if known
$(document).ready(function () {
  var shop = getCookie("shop");

  if (shop) {
    $("a.button").each(function () {
      var oldHref = $(this).attr("href");
      var [basePath, searchParams] = oldHref.split("?");
      var params = new URLSearchParams(searchParams);
      params.set("shop", shop);
      $(this).attr("href", `${basePath}?${params}`);
    });
  }
});
